import React, {Component} from 'react';
import '../../../styles/Home.css'
import {Link} from "react-router-dom";
import AdminService from "../../../admin/adminComponents/AdminService";
import Panel from "../Panel";

export default class Eventy extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            data: []
        }
    }

    componentWillMount() {
        AdminService.getEventy(JSON.parse(sessionStorage.getItem('loggedIn')).idKl)
            .then(function (response) {
                let res = response.data;
                this.setState({data: res, loading: false})
            }.bind(this)).catch(err => {
            console.log(err)
        })
    }

    render() {
        return <Panel>
            <div>
                <h4 style={{textAlign: 'center', marginBottom: 20}}><b>Eventy</b></h4>
                <br/>
                {this.state.loading ? <div>
                    <div className="loaderDim" style={{textAlign: 'center', paddingTop: 50, paddingBottom: 50}}><i
                        className="fa fa-spinner fa-pulse fa-2x fa-fw"
                        style={{
                            color: '#58b13d'
                        }}> </i></div>
                </div> : <div>
                    {this.state.data.length !== 0 ? <div>
                        {this.state.data.sort((a, b) => parseInt(b.id) - parseInt(a.id)).map((item, index) => {
                            return <Link to={'/konto/eventy/' + item.id} className="eventLink" key={item.id}>
                                <div className="wynik row eventWynik">
                                    <div className="col-lg-5"><i className="fa fa-star"/> {item.tytul}</div>
                                    <div className="col-lg-3">{item.czyZapisany ? <div className={'zapisany'}><i className={'fa fa-check'}/> Zapisano</div> : null }</div>
                                    <div className="col-lg-4 text-right small" style={{color: '#676767'}}>Data
                                        utworzenia: {item.dataWpisu}</div>
                                </div>
                            </Link>
                        })}</div> : <div className={'text-center'}>Brak eventów</div>}</div>}
            </div>
        </Panel>
    }

}



// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/Eventy.js